import type { RulePreset } from './lotteryData';
import { getRuleBuilderCatalogPresets } from './ruleBuilderCatalog';
import type { RuleId, RuleSchemaEntry } from './ruleSchema';
import type { TicketRule } from '../types/rules';

/** Default stack: start empty; user adds rules from the catalog below. */
export function createDefaultRules(): TicketRule[] {
  return [];
}

/** Presets shown in “Add a rule” — driven by `RULE_BUILDER_CATALOG_IDS`. */
export function createDefaultPresets(): RulePreset[] {
  return getRuleBuilderCatalogPresets();
}

function newRuleInstanceId(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `rule-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function buildRuleFromPreset(id: RuleId, preset: RulePreset, schema: RuleSchemaEntry): TicketRule {
  return {
    instanceId: newRuleInstanceId(),
    id,
    name: preset.name,
    presetIcon: preset.icon,
    weight: 10,
    enabled: true,
    settings: { ...schema.defaults },
  };
}
